import React from "react";
import { Box } from "@mui/material";
import { styled } from '@mui/material/styles';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import PropTypes from "prop-types";

const KanbanCardProgress = (props) => {

    const getColor = (percentage) => {
        switch (percentage) {
            case 100:
            case 90:
                return '#00D084';
            case 80:
            case 70:
            case 60:
                return '#FFBA00';
            case 50:
            case 40:
            case 30:
                return '#FFBA00';
            case 20:
            case 10:
                return '#CF2E2E';
        }
    }

    const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
        height: 10,
        borderRadius: 5,
        [`&.${linearProgressClasses.colorPrimary}`]: {
            backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
        },
        [`& .${linearProgressClasses.bar}`]: {
            borderRadius: 5,
            backgroundColor: getColor(getPercentage())
        },
    }));

    const getPercentage = () => {
        let Difference_In_Time = new Date() - new Date(props.createdAt);
        let percentage = 100 - (10 * (Math.floor(Difference_In_Time / (1000 * 3600 * 24))));
        if (percentage < 0) {
            percentage = 0;
        }
        if (percentage > 100) {
            percentage = 100;
        }
        return percentage;
    }

    return (
        <>
            <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <BorderLinearProgress variant="determinate" value={getPercentage()} />
                </Box>
                <Box sx={{ minWidth: 35 }}>
                    {(10 - (getPercentage() / 10)) + 'd'}
                </Box>
            </Box>
        </>
    );
}

KanbanCardProgress.propTypes = {
    createdAt: PropTypes.string
};

export default KanbanCardProgress;